module.exports = __webpack_public_path__ + "static/img/Angus.Monfries.859f383.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Angus.Monfries.jpg
// module id = mjx7
// module chunks = 0